"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserNotifications = exports.markNotificationsAsRead = exports.markNotificationsAsViewed = exports.getNextPageOfNotifications = exports.getUserNotifications = exports.getServerSideNotifications = void 0;

var _apiServices = require("@pingum/api-services");

var _eventSourcePolyfill = require("event-source-polyfill");

var types = _interopRequireWildcard(require("./types"));

var _networkDispatcher = require("../networkDispatcher");

var _tenantHelper = require("../util/tenantHelper");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var eventSource = null;
var reconnectAttempt = 0;

var isStringJson = function isStringJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

var getServerSideNotifications = function getServerSideNotifications(auth0UserId) {
  return function (dispatch) {
    if (eventSource != null) {
      eventSource.close();
      eventSource = null;
    }

    eventSource = new _eventSourcePolyfill.EventSourcePolyfill(encodeURI("".concat(env.REACT_APP_NOTIFICATION_API, "/users/").concat(auth0UserId, "/updates")), {
      headers: {
        Authorization: "Bearer ".concat(_apiServices.AuthService.getToken()),
        'X-Tenant': (0, _tenantHelper.getTenantFromUrl)()
      }
    });
    eventSource.addEventListener('open', function () {
      reconnectAttempt = 0;
    });
    eventSource.addEventListener('message', function (event) {
      if (event.data && isStringJson(event.data)) {
        // for now, we just want to increment the unviewed count
        dispatch({
          type: types.NOTIFICATIONS_INCREMENT_UNVIEWED_COUNT
        });
      }
    });
    eventSource.addEventListener('error', function () {
      // close out the last connection
      eventSource.close();
      eventSource = null; // dispatch the connection error
      // TODO do we want to or need to do anything when we are disconnected from SSE?
      // let's try to reconnect

      if (reconnectAttempt < 6) {
        setTimeout(function () {
          reconnectAttempt += 1;
          getServerSideNotifications(dispatch);
        }, reconnectAttempt === 0 ? 100 : 30000); // if this is first reconnect try, attempt right away, could be blue green deployment
      }
    });
  };
};

exports.getServerSideNotifications = getServerSideNotifications;

var getUserNotifications = function getUserNotifications(auth0UserId) {
  return function (dispatch) {
    getServerSideNotifications(auth0UserId)(dispatch);
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.NOTIFICATION_REQUESTED,
      successType: types.NOTIFICATION_SUCCESS,
      errorType: types.NOTIFICATION_ERROR,
      promise: _apiServices.UserNotificationService.getUserNotifications(auth0UserId),
      defaultErrorMessage: 'There was a problem loading notifications',
      responseName: 'responseData'
    });
  };
};

exports.getUserNotifications = getUserNotifications;

var getNextPageOfNotifications = function getNextPageOfNotifications(auth0UserId, page, size) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.NOTIFICATION_PAGE_REQUESTED,
      successType: types.NOTIFICATION_PAGE_SUCCESS,
      errorType: types.NOTIFICATION_PAGE_ERROR,
      promise: _apiServices.UserNotificationService.getPagedUserNotifications(auth0UserId, page, size),
      defaultErrorMessage: 'There was a problem loading notifications',
      responseName: 'responseData'
    });
  };
};

exports.getNextPageOfNotifications = getNextPageOfNotifications;

var markNotificationsAsViewed = function markNotificationsAsViewed(auth0UserId, notifications) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.NOTIFICATIONS_MARK_AS_VIEWED_REQUESTED,
      successType: types.NOTIFICATIONS_MARK_AS_VIEWED_SUCCESS,
      errorType: types.NOTIFICATIONS_MARK_AS_VIEWED_ERROR,
      promise: _apiServices.UserNotificationService.updateUserNotifications(auth0UserId, {
        readNotificationsTimestamps: [],
        viewedNotificationsTimestamps: notifications.map(function (notification) {
          return notification.notificationTimestamp;
        })
      }),
      defaultErrorMessage: 'There was a problem editing the notifications',
      responseName: 'userNotifications'
    });
  };
};

exports.markNotificationsAsViewed = markNotificationsAsViewed;

var markNotificationsAsRead = function markNotificationsAsRead(auth0UserId, notifications) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.NOTIFICATIONS_MARK_AS_READ_REQUESTED,
      successType: types.NOTIFICATIONS_MARK_AS_READ_SUCCESS,
      errorType: types.NOTIFICATIONS_MARK_AS_READ_ERROR,
      promise: _apiServices.UserNotificationService.updateUserNotifications(auth0UserId, {
        readNotificationsTimestamps: notifications.map(function (notification) {
          return notification.notificationTimestamp;
        }),
        viewedNotificationsTimestamps: []
      }),
      defaultErrorMessage: 'There was a problem editing the notifications',
      responseName: 'userNotifications'
    });
  };
};

exports.markNotificationsAsRead = markNotificationsAsRead;

var updateUserNotifications = function updateUserNotifications(auth0UserId, request) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.NOTIFICATION_EDIT_REQUESTED,
      successType: types.NOTIFICATION_EDIT_SUCCESS,
      errorType: types.NOTIFICATION_EDIT_ERROR,
      promise: _apiServices.UserNotificationService.updateUserNotifications(auth0UserId, request),
      defaultErrorMessage: 'There was a problem editing the notifications',
      responseName: 'userNotifications'
    });
  };
};

exports.updateUserNotifications = updateUserNotifications;